export class ActiveTabChange {
  static readonly type = '[AqmAgentReport] ActiveTabChange';

  constructor(public activeTab: number) {}
}
